/* global localStorage */

import * as MutationTypes from './mutation-types'
import { mapGetters, mapState, mapSetters } from 'vuex'
import dateUtil from "../services/date";
import axios from '../backend/vue-axios'

const getDefaultState = () => {
  return {
    is_company: false,
    company_name: '',
    title: '',
    firstname: '',
    lastname: '',
    nationality: '',
    dob: '',
    street: '',
    zip: '',
    city: '',
    has_holder: 0,
    holder_firstname: '',
    holder_lastname: '',
    holder_zip: '',
    holder_city: '',
    holder_street: '',
  }
}

const state = getDefaultState()

const getters = {
}

const actions = {
  resetOffer({ commit }) {
    commit('resetState')
  },
  fetchOffer({ commit }, token) {
    axios.get("/spa/evbs/" + token).then((response) => {
      commit('setEvbItems', response.data.evb);
    })
      .catch((e) => {
        console.log(e);
      });
  },
}

const mutations = {
  setEvbItems(state, evbData) {
    console.log("YEHA!");
    console.log(evbData);
    Object.assign(state, evbData);
  },
  setEvb(state, item) {
    state = item;
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
